export interface IBankApiSetting {
  id?: number;
  sellConfirmationEndpoint?: string;
  vendorName?: string | null;
  vendorCif?: string | null;
}

export const defaultValue: Readonly<IBankApiSetting> = {};
